// cherryQuotes.js

// 200+ personalized, uplifting, flirty, and funny quotes for Cherry
const cherryQuotes = [
  "Cherry, your panda hands can conquer the world, one event at a time!",
  "Even social media bows down when Cherry is in charge.",
  "Gappu believes in you more than Wi-Fi believes in 100% signal, Cherry!",
  "Cherry, your smile is the hashtag everyone wants trending.",
  "Don’t stress, Cherry! Your panda hands are magical for turning chaos into charm.",
  "The event won’t know what hit it, because Cherry’s here to slay.",
  "Cherry, if confidence had a face, it’d be yours holding a coffee.",
  "Gappu’s cheering squad: 1. Me 2. You 3. Your panda hands.",
  "Cherry, even algorithms pause to admire your creativity.",
  "Keep calm, Cherry—your brilliance is viral-ready.",
  "Gappu knows, no one can handle this event like Cherry, the panda-hand queen.",
  "Cherry, your energy could make even Monday jealous.",
  "Your panda hands are proof that cute can be powerful.",
  "Cherry, every post you make is a love letter to the internet.",
  "Even the hardest campaign bows to Cherry’s charm.",
  "Panda hands? More like power hands, Cherry!",
  "Cherry, social media marketing has never been this adorable and deadly efficient.",
  "No stress, Cherry—Gappu’s got your back, and so do your panda hands.",
  "Cherry, every awkward moment turns cute when you’re handling it.",
  "If confidence had a sound, it would be Cherry’s laughter echoing through the office.",
  "Gappu says: You got this, Cherry, with your panda hands leading the way!",
  "Cherry, your event is basically a festival with your touch.",
  "Every post, every story, every smile—you make it iconic, Cherry.",
  "Even the hardest day can’t resist Cherry’s charm and panda hands.",
  "Cherry, if nervousness comes knocking, throw it a panda-hand high-five and laugh.",
  "Your creativity is viral, your panda hands legendary, Cherry.",
  "Keep sparkling, Cherry—Gappu loves your shine.",
  "Cherry, the universe pauses when your panda hands start creating magic.",
  "Stress? Never met Cherry’s panda hands in action.",
  "Cherry, your laugh alone could go viral without an internet connection.",
  "Every follower is secretly cheering for Cherry—and her panda hands.",
  "Gappu is convinced: No event can survive Cherry without falling in love with her energy.",
  "Cherry, your confidence is like caffeine—instant energy for everyone around.",
  "Even algorithms wish they were as charming as you, Cherry.",
  "Cherry, when you smile, even hashtags blush.",
  "Your panda hands are cute, but your brain? Legendary.",
  "Gappu says: Take a deep breath, Cherry, and slay like only you can.",
  "Cherry, the event is lucky to have you, the panda-hand commander.",
  "Stress melts when Cherry laughs—fact.",
  "Even if social media crashes, Cherry will keep the world trending.",
  "Cherry, your panda hands could probably negotiate peace between cats and dogs.",
  "Confidence suits you, Cherry—wear it with those panda hands!",
  "Your ideas are gold, Cherry, your charm platinum.",
  "Cherry, you’re not nervous—you’re excited, and Gappu sees it.",
  "Panda hands in action = world domination, Cherry-style.",
  "Cherry, every awkward moment becomes a story worth sharing.",
  "Your energy is contagious, your smile addictive, Cherry.",
  "Even the event organizers take notes from Cherry’s flair.",
  "Cherry, your panda hands could launch rockets if you wanted.",
  "Gappu’s tip: Keep calm, your panda hands are unbeatable.",
  "Cherry, the world needs your cute + chaos + magic combo.",
  "Every campaign, every post, every laugh—Cherry makes it iconic.",
  "Even Monday mornings cheer when Cherry enters the room.",
  "Cherry, you handle pressure like a pro, and cuteness like a boss.",
  "Your panda hands are tiny superheroes, Cherry.",
  "Cherry, your energy turns stress into sparkle.",
  "No algorithm can resist Cherry’s charm.",
  "Cherry, even spreadsheets start smiling when you touch them.",
  "Gappu knows: Panda hands + charm = unstoppable Cherry.",
  "Cherry, your ideas are trending before they even go live.",
  "Keep your panda hands busy, your mind sharp, and your smile unstoppable.",
  "Cherry, your event is basically a Gappu-approved masterpiece.",
  "Even social media pauses to watch Cherry slay.",
  "Cherry, you’re stress-proof, charm-loaded, and Gappu-loved.",
  "Every follower secretly hopes to be as cute as Cherry’s panda hands.",
  "Cherry, your energy is like a viral reel—unskippable.",
  "Gappu says: Keep shining, the world is your stage, Cherry.",
  "Cherry, the event is just a backdrop for your brilliance.",
  "Panda hands ready? Confidence mode: ON. Cherry style!",
  "Even deadlines smile when Cherry shows up.",
  "Cherry, your charm is louder than any microphone.",
  "Keep rocking, Cherry—the internet isn’t ready for your level of awesome.",
  "Cherry, Gappu knows: You don’t handle events, you enchant them.",
  "Even chaos takes a coffee break when Cherry walks in.",
  "Cherry, your panda hands + brain combo = unstoppable magic.",
  "Keep calm and let Cherry’s charm take over.",
  "Your social media posts are basically love letters, Cherry.",
  "Cherry, every nervous thought melts when Gappu sends love vibes.",
  "Even hashtags can’t compete with Cherry’s cuteness.",
  "Cherry, your brilliance is sparkling enough for the whole office.",
  "Panda hands up, stress down—Cherry style!",
  "Gappu cheering from afar: You got this, Cherry!",
  "Cherry, your ideas are a traffic jam for inspiration.",
  "Even Mondays cheer for Cherry’s energy.",
  "Cherry, your laughter could break the internet faster than a trending meme.",
  "Your panda hands are secretly the event MVPs.",
  "Cherry, stress has nothing on you and your charm.",
  "Every challenge becomes fun when Cherry’s around.",
  "Gappu says: Keep rocking, Cherry—you make work magical.",
  "Cherry, your smile alone could replace caffeine.",
  "Even spreadsheets admire Cherry’s panda hands.",
  "Cherry, your energy is a full-proof mood booster.",
  "Panda hands, brain power, cuteness overload—Cherry wins.",
  "Cherry, you’re the reason social media takes a happy break.",
  "Every event is better with Cherry in charge.",
  "Gappu is proud: Panda hands + charisma = Cherry style.",
  "Cherry, your energy turns chaos into laughter.",
  "Even deadlines pause to watch Cherry’s magic.",
  "Cherry, you’re stress-proof, energy-loaded, Gappu-loved.",
];

// Short 2-line flirty, uplifting messages for Cherry
const cherryFlirtyCheer = [
  "Cherry, your panda hands are my favorite power move 💖. Keep slaying, superstar!",
  "Even if the world is chaotic, your smile makes everything trending 🌟. Go Cherry!",
  "Gappu believes in you more than Wi-Fi believes in signal 📶. You got this, Cherry!",
  "Cherry, your charm + skills = unstoppable event magic 💫. Rock it, my queen!",
  "Panda hands ready? Confidence mode: ON. Gappu’s cheering you nonstop 🥰!",
];

// Export arrays for use in other files
export { cherryQuotes, cherryFlirtyCheer };
